import styled, { css } from 'styled-components';

const Bound = styled.div`
    display: flex;
    width: 322px;
    align-items: center;
    /* justify-content: space-between; */
    max-width: 322px;
    border-radius: 4px;
    padding: 12px 0;
    font-family: "SVN-Gilroy";
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    position: fixed;
    animation-fill-mode: forwards;

    &.fade-in {
        animation-name: animatetop;
        animation-duration: 1s;
    }

    &.fade-out {
        animation-name: fade-out;
        animation-duration: 1s;
    }

    .ic-detail {
        margin-left: 26px;
    }

    .content {
        margin-left: 16px;
        flex-grow: 1;
    }

    .btn-close {
        margin: 0 17.5px;

        :hover {
            cursor: pointer;
        }
    }

    ${props => css`${props.specificStyles}`}
    ${props => props.extendStyles}

    @keyframes animatetop {
        from {top: -300px; opacity: 0}
        to {top: 0; opacity: 1}
    }

    @keyframes fade-out {
        from {top: 0; opacity: 1}
        to {top: -300px; opacity: 0}
    }
`;

export {
    Bound
}